import OrthoCareETPage from "../../components/pages/orthocarepage";
export default OrthoCareETPage;
